import { render, staticRenderFns } from "./PolicyDocuments.vue?vue&type=template&id=c15741fc&scoped=true"
import script from "./PolicyDocuments.vue?vue&type=script&lang=js"
export * from "./PolicyDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c15741fc",
  null
  
)

export default component.exports